// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "javascript/chunks/" + "b5b71101998a036c4f21" + ".min.js";
};